import React from 'react'
import LayoutAdmin from './layoutadmin'
import Grid from 'material-ui/Grid'
import Avatar from 'material-ui/Avatar'
import Card, { CardHeader, CardMedia, CardContent, CardActions } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import { inject, observer } from 'mobx-react'
import Button from 'material-ui/Button'
import {deepOrange,deepPurple} from 'material-ui/colors'
import Icon from 'material-ui/Icon'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog'
import TextField from 'material-ui/TextField'
import { withLayoutAdmin } from '../../utils/hoc'
import T from 'i18n-react'



@inject('admin','adminui') @observer
class Users extends React.Component {
 render () {
  const admin = this.props.admin, adminui = this.props.adminui

  return (
    <Grid container direction="row" justify="center" alignItems="flex-start" spacing={Number(0)}>
     {admin.users.map( (user,index) => {
        let color = index % 2 === 0 ? deepOrange[500] : deepPurple[500]
        return <Grid item xs={12} sm={6} md={4} key={'user-'+index}>
                <UserCard user={user} color={color}/>
               </Grid>
      })
     }

    <Button fab color="secondary" dense={true} aria-label="add" className="admin-add-user" onClick={adminui.handleOpenCreateUserDialog}>
     <Icon>add</Icon>
    </Button>

    <CreateUserDialog />
    <ChangePasswordDialog />
    <ChangeMailDialog />
    <DeleteUserDialog />

   </Grid>
  )
 }

 componentWillMount () {
   this.props.admin.getUsers()
 }

}

@inject('adminui') @observer
class UserCard extends React.Component {
  render () {
    const adminui = this.props.adminui, user = this.props.user

    return (
      <Card className="admin-user-card">
       <CardHeader
        avatar={<Avatar style={{backgroundColor:this.props.color}}> {user.firstChar} </Avatar>}
        title={user.login}
        subheader={user.created}
       />
       <CardActions disableActionSpacing>
        <Button color="secondary" dense onClick={adminui.handleOpenChangePasswordDialog.bind(this,user)}> {T.translate("admin.settings.changePassword")} </Button>
        <Button color="secondary" dense onClick={adminui.handleOpenChangeMailDialog.bind(this,user)}> {T.translate("admin.settings.mailNotification")} </Button>
        {user.id !== 1 && <Button dense color="secondary" onClick={adminui.handleOpenDeleteUserDialog.bind(this,user)}> {T.translate("meta.delete")} </Button>}
       </CardActions>
      </Card>
    )
  }
}

@inject('admin','adminui') @observer
class CreateUserDialog extends React.Component {
  render () {
    const adminui = this.props.adminui, admin = this.props.admin

    return (
      <Dialog open={adminui.openCreateUserDialog} onRequestClose={adminui.handleCloseCreateUserDialog}>
        <DialogTitle>{T.translate("admin.settings.createUser")}</DialogTitle>
        <DialogContent>
        <TextField
          id="new-user-loginname"
          fullWidth
          placeholder={T.translate("admin.login.name")}
          onChange={e=>admin.setCreatedUserLoginname(e.target.value)}
        />
        <TextField
          id="new-user-password"
          fullWidth
          type="password"
          placeholder={T.translate("admin.login.password")}
          onChange={e=>admin.setCreatedUserPassword(e.target.value)}
        />
        </DialogContent>
        <DialogActions>
          <Button onClick={adminui.handleCloseCreateUserDialog} color="primary">
            {T.translate("meta.close")}
          </Button>
          <Button onClick={this.createUser} color="secondary">
            {T.translate("admin.settings.createUser")}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  createUser = () => {
    this.props.admin.createUser(success => { this.props.adminui.handleCloseCreateUserDialog() })
  }
}


@inject('adminui','messenger') @observer
class ChangePasswordDialog extends React.Component {
  render () {
    const adminui = this.props.adminui, user = adminui.currentUser
    return (
      <Dialog open={adminui.openChangePasswordDialog} onRequestClose={adminui.handleCloseChangePasswordDialog}>
        <DialogTitle>{T.translate("admin.settings.changePassword")}</DialogTitle>
        <DialogContent>
        <TextField
          id="newPW"
          type="password"
          fullWidth
          placeholder={T.translate("admin.login.password")}
          onChange={e=>user.setNewPassword(e.target.value)}
        />
        </DialogContent>
        <DialogActions>
          <Button onClick={adminui.handleCloseChangePasswordDialog} color="primary">
            {T.translate("meta.close")}
          </Button>
          <Button onClick={this.changePassword} color="secondary">
            {T.translate("admin.settings.changePassword")}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  changePassword = () => {
    const adminui = this.props.adminui
    adminui.currentUser.changePassword(success => {
      adminui.handleCloseChangePasswordDialog()
      if (success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.CHANGED_PASSWORD)
      } else {
        this.props.messenger.handleOpen(this.props.messenger.messages.ERR_CHANGE_PASSWORD)
      }
    })
  }
}

@inject('admin','adminui','messenger') @observer
class ChangeMailDialog extends React.Component {
  render () {
    const adminui = this.props.adminui, user = adminui.currentUser
    return (
      <Dialog open={adminui.openChangeMailDialog} onRequestClose={adminui.handleCloseChangeMailDialog}>
        <DialogTitle>{T.translate("admin.settings.mailNotification")}</DialogTitle>
        <DialogContent>
        <p> {T.translate("admin.settings.redirectMailText")} </p>
        <TextField
          id="mail"
          type="email"
          fullWidth
          defaultValue={user.mail}
          placeholder={T.translate("admin.settings.mail")}
          onChange={e=>user.setMail(e.target.value)}
          onBlur={this.changeMail}
        />
        </DialogContent>
        <DialogActions>
          <Button onClick={adminui.handleCloseChangeMailDialog} color="primary">
            {T.translate("meta.close")}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  changeMail = () => {
    const adminui = this.props.adminui
    adminui.currentUser.changeMail(success => {
      adminui.handleCloseChangeMailDialog()
      if (success) {
        this.props.messenger.handleOpen(this.props.messenger.messages.CHANGED_MAIL)
      } else {
        this.props.messenger.handleOpen(this.props.messenger.messages.ERR_CHANGE_MAIL)
      }
    })
  }
}

@inject('admin','adminui') @observer
class DeleteUserDialog extends React.Component {
  render () {
    const adminui = this.props.adminui, user = adminui.currentUser
    return (
      <Dialog
       open={adminui.openDeleteUserDialog}
       onRequestClose={adminui.handleCloseDeleteUserDialog}
       ignoreBackdropClick
       ignoreEscapeKeyUp
       maxWidth="xs"
      >
        <DialogTitle>{user.login + " " + T.translate("meta.delete")}</DialogTitle>
        <DialogActions>
          <Button onClick={adminui.handleCloseDeleteUserDialog} color="primary">
            {T.translate("meta.close")}
          </Button>
          <Button onClick={this.deleteUser} color="secondary">
            {T.translate("meta.delete")}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  deleteUser = () => {
    this.props.admin.deleteUser(this.props.adminui.currentUser.id,(success) => {
     this.props.adminui.handleCloseDeleteUserDialog()
    })
  }
}


export default withLayoutAdmin(Users)



// WEBPACK FOOTER //
// ./src/components/admin/users.js